var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M27 16a1 1 0 00.673-1.74l-11-10a1 1 0 00-1.346 0l-11 10A1 1 0 005 16h5v7.667a1 1 0 001 1h10a1 1 0 001-1V16h5zM11 26a1 1 0 000 2h10a1 1 0 100-2H11z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }